export default class UsageService {
  constructor($q) {
    this.$q = $q;
    //The list below are the names of data points in priority order
    this.Usage_DataPointS = [
      'operating_hours',
      'unit_hour_meter',
      'engine_hour_meter',
      'run_time',
      'utilization_time',
      'mach_hours'
    ];
  }

  getUsageSeriesForAssets(series = [], assetIds = []) {
    return this.$q((resolve) => {
      const assetsUsageSeries = {};
      series.forEach((ser) => {
        //first tag is data point id
        [ser.dataPointId] = ser.tags || [];

        //check if onei3:dp_std=operating_hours been set on the series
        const { equipment, ['onei3:dp_std']: usageSeries } = ser.attrs || {};

        const usedAt = ser.last?.changedAt || ser.last?.t;
        if (usedAt) {
          ser.usedAt = usedAt;
          ser.usedAtInDays = this.getDaysNumberFromToday(usedAt);
          ser.lastReportedInDays =
            ser.last?.t && ser.last?.t !== usedAt
              ? this.getDaysNumberFromToday(ser.last?.t)
              : ser.usedAtInDays;
        }

        if (usageSeries == 'operating_hours') {
          //add or override asset series
          assetsUsageSeries[equipment] = ser;
          return;
        }

        // if no operating_hours attrs check if the series one of the predefined one
        if (ser.dataPointId && this.Usage_DataPointS.includes(ser.dataPointId)) {
          if (equipment in assetsUsageSeries) {
            // override the series if the new one has higher priority by being top in the list
            if (
              this.Usage_DataPointS.indexOf(assetsUsageSeries.dataPointId) <
              this.Usage_DataPointS.indexOf(ser.dataPointId)
            )
              assetsUsageSeries[equipment] = ser;
          } else {
            assetsUsageSeries[equipment] = ser;
          }
        }
      });

      const assetHasUsageDataPoints = Object.keys(assetsUsageSeries);
      const seriesIds = assetHasUsageDataPoints.map((k) => assetsUsageSeries[k].id);
      //find if there are assets we requested usage but they have not reported any yet, then set it as undefined.
      const assetsWithNoUsageDataPoints = assetIds.filter(
        (a) => !assetHasUsageDataPoints.includes(a),
      );
      assetsWithNoUsageDataPoints.forEach((a) => {
        assetsUsageSeries[a] = undefined;
      });

      resolve({ assetsUsageSeries, seriesIds });
    });
  }

  getDaysNumberFromToday(date) {
    const num = moment().diff(moment(date), 'days', true);
    return Math.round(num * 100) / 100;
  }

  aggregateDataPerPeriod(seriesData = []) {
    return this.$q((resolve) => {
      const assetsUsage = {};
      seriesData.forEach((serObj) => {
        const { series = {}, data = [] } = serObj;
        const { equipment } = series.attrs || {};
        const lastUsage = series.last?.v;
        const lastUsageAt = series.last?.changedAt || series.last?.t;
        if (!equipment) return;
        assetsUsage[equipment] = { ...serObj, lastUsage, lastUsageAt };
        const usagePeriod = {
          today: 0,
          yesterday: 0,
          '7d': 0,
          '14d': 0,
          '28d': 0,
        };
        //TODO calculate usage per day form the result (next last -prev last)
        assetsUsage[equipment].usage = usagePeriod;
      });

      resolve(assetsUsage);
    });
  }
}
